@use '~/theme/theme' as *;

.filters {
  padding: 0 spacing(3);
}

.filtersRow {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: spacing(2);
  align-items: flex-end;
}

.primaryFiltersRow {
  grid-template-columns: 1fr 1fr calc(33% - (40px + spacing(3))) auto;
}

.inlineSearchFilter,
.counterpartFilter {
  width: 100%;
}
